import { Menu } from 'lucide-react'
import { NotificationBell } from '@/features/notifications/components/notification-bell'
import { TenantSwitcher, UserMenu } from './user-menu'

type TopBarProps = {
  tenantId: string
  onOpenMenu?: () => void
}

export function TopBar({ tenantId, onOpenMenu }: TopBarProps) {
  return (
    <header className="flex h-14 shrink-0 items-center justify-between gap-2 border-b border-border-default bg-surface-toolbar px-3 shadow-sm sm:gap-4 sm:px-4">
      <div className="flex min-w-0 items-center gap-2">
        <button
          type="button"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-border-default text-text-primary md:hidden"
          aria-label="Open menu"
          onClick={onOpenMenu}
        >
          <Menu className="h-5 w-5" aria-hidden />
        </button>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-text-primary">Workspace</p>
          <p className="hidden truncate text-xs text-text-muted sm:block">Internal operations</p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <TenantSwitcher />
        <NotificationBell tenantId={tenantId} />
        <UserMenu />
      </div>
    </header>
  )
}
